import { render, staticRenderFns } from "./BaseVerticalDataCell.vue?vue&type=template&id=1bcb90db&scoped=true&"
import script from "./BaseVerticalDataCell.vue?vue&type=script&lang=js&"
export * from "./BaseVerticalDataCell.vue?vue&type=script&lang=js&"
import style0 from "./BaseVerticalDataCell.vue?vue&type=style&index=0&id=1bcb90db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcb90db",
  null
  
)

export default component.exports